<template>
    <div class="md:max-w-[46.625rem] md:mx-auto ">
        <Title
            :text="$route.meta.pageTitle"
            style-code-page
        />
        <div class="border border-gray-200 rounded-md p-7 md:bg-white">
            <div class="md:max-w-[36rem] md:mx-auto text-center">
                <template v-if="selectMobile">
                    <p class="text-lg text-gray-900">
                        請選擇您要發送動態密碼之行動電話號碼
                    </p>
                    <div class="my-6 space-y-3 flex flex-col items-center">
                        <Radio
                            v-for="(item,index) in mobileList"
                            :key="index"
                            v-model:checkedValue="otpMobile"
                            :value="item"
                            :text="maskMobile(item)"
                            class="mb-2.5 items-baseline"
                        />
                        <!-- <Radio
                            v-model:checkedValue="otpMobile"
                            value="1234567"
                            name="mobile"
                        >
                            <span
                                class="text-lg"
                                :class="[otpMobile==='1234567'?'text-gray-900':'text-gray-700']"
                            >
                                0988112345
                            </span>
                        </Radio> -->

                        <button
                            :disabled="isSpin || !otpMobile"
                            class="btn rounded-full px-6"
                            :class="[isSpin&&'opacity-70', !otpMobile?'btn-accent':'gradient-primary']"
                            @click="otpMobile?checkOTP():''"
                        >
                            <SvgIcon
                                v-if="isSpin"
                                icon-name="loading"
                                class="animate-spin h-6 w-6 mr-2 text-white"
                            />
                            <span
                                v-if="isSpin"
                                class="text-white"
                            >
                                Loading
                            </span>
                            <span v-else>
                                發送動態密碼
                            </span>
                        </button>
                    </div>
                </template>
                <template v-else>
                    <p class="text-lg text-gray-900">
                        已發送動態密碼至行動電話
                    </p>
                    <h4 class="text-2xl mt-2.5 mb-5">
                        {{ maskMobile(otpMobile) }}
                    </h4>
                    <div class="flex max-w-[19.7rem] sm:mx-auto">
                        <input
                            v-model.trim="otpCode"
                            type="text"
                            autocomplete="off"
                            maxlength="10"
                            inputmode="numeric"
                            class="input-base grow rounded-r-none"
                            placeholder="請輸入動態密碼"
                            :disabled="isInputDisabled"
                            @input="validateOtpCode"
                        >
                        <button
                            class="p-0 w-[7rem] rounded-l-none rounded-r-md text-sm xs:text-base border border-l-0 flex-shrink-0"
                            :class="[counting|| sendTimes===3?'bg-gray-50 border-gray-200 text-gray-200':'gradient-primary']"
                            :disabled="counting || sendTimes===3"
                            @click="resendOtp"
                        >
                            <span
                                v-if="isSpin"
                                class="w-full flex justify-center"
                            >
                                <SvgIcon
                                    icon-name="loading"
                                    class="animate-spin h-6 w-6 mr-2 text-white"
                                />
                            </span>
                            <vue-countdown
                                v-else-if="counting"
                                v-slot="{ totalSeconds }"
                                :time="60000"
                                @end="onCountdownEnd"
                            >
                                {{ totalSeconds }}秒後
                                <p class="text-sm leading-none">
                                    重新發送
                                </p>
                            </vue-countdown>
                            <p v-else>
                                重新發送
                            </p>
                        </button>
                    </div>
                    <p class="error-msg mx-auto max-w-[25rem] h-4">
                        {{ errorMsg }}
                    </p>
                    <button
                        class="btn gradient-primary rounded-full text-white mt-1"
                        @click="goNext"
                    >
                        確定
                    </button>
                </template>
            </div>
        </div>
        <ol class="list-decimal ml-6 my-4 text-gray-900">
            <li class="mb-2 md:mb-1.5">
                系統將於1~2分鐘內傳送動態密碼予您。
            </li>
            <li class="mb-2 md:mb-1.5">
                勿關閉此視窗，請您收到動態密碼後，即刻輸入進行認證。
            </li>
            <li class="mb-2 md:mb-1.5">
                為確保個人資料安全性，此動態密碼自發送後起5分鐘內有效。
            </li>
        </ol>
        <Loading :is-loading="isLoading" />
    </div>
</template>

<script>
import { ref, inject, reactive, toRefs, computed } from 'vue';
import { useStore } from 'vuex';
import Loading from '@/components/Loading.vue';
import Radio from '@/components/radios/Radio.vue';
import Title from '@/components/text/Title.vue';
import { useRouter } from 'vue-router';
import routeName from '@/router/constant.js';
import { getInfoOTP, postSentOTP, postVerifyOTP, postResentOTP } from '@/apis/OTP';
import { postCheckBDPOTP } from '@/apis/otpCheck';
import dialogContnet from './dialogContent.js';
import { notification } from '@/utils/notification';
import { postChooseOtp } from '@/apis/eNotifyPromo';
import { getContactInfo } from '@/apis/system.js';
import { maskMobile } from '@/utils/maskUtils.js';

export default {
    components: {
        Title,
        Loading,
        Radio
    },
    setup() {
        const $vfm = inject('$vfm');
        const router = useRouter();
        const store = useStore();
        const counting = ref(false);
        const isLoading = ref(false);

        const selectMobile = ref(true);
        const isSpin = ref(false);
        const isInputDisabled = ref(false);
        const otpCode = ref('');
        const otpMobile = ref('');
        const sendTimes = ref(0);
        const verifyErrorTimes = ref(0);
        const errorMsg = ref('');
        const mobileNumber = reactive({
            old: '',
            lastNumber: '',
            mobileList: [],
        });
        const isNONCustom = computed(() => store.state.eNotify.user?.enotifyPromo?.memberType === 'NON');

        /** 發送驗證碼 */
        const sendOTP = () => {
            isSpin.value = true;
            const forceSend = false; // default false

            postSentOTP(forceSend, otpMobile.value);
            setTimeout(() => {
                // isShowOTPObject.value = true;
                // disabledRadio.value = true;
                counting.value = true;
                isSpin.value = false;
            }, 3000);
        };

        /** 燈箱：交易失敗 */
        const modalShow = (params) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        switch (params.id) {
                            case 'otpError5Times': {
                                store.dispatch('permissions/goFubonOfficial');
                                break;
                            }
                            case 'checkBDPOTP': {
                                sendOTP();
                                break;
                            }
                        }
                        $vfm.hide('DialogBase');
                    },
                    cancel() {
                        switch (params.id) {
                            case 'checkBDPOTP': {
                                store.dispatch('permissions/goFubonOfficial');
                                break;
                            }
                        }
                        $vfm.hide('DialogBase');
                    }
                },
            });
        };

        const resendOtp = () => {
            // isLoading.value = true;
            isSpin.value = true;
            errorMsg.value = '';
            isInputDisabled.value = true;
            postResentOTP().then(res => {
                verifyErrorTimes.value = 0;
                sendTimes.value = res.data.resendTimes;
                if (sendTimes.value === 3) {
                    modalShow(dialogContnet.resend3times);
                }
            });
            setTimeout(() => {
                counting.value = true;
                isInputDisabled.value = false;
                isLoading.value = false;
                isSpin.value = false;
                otpCode.value = '';
            }, 3000);
        };
        const onCountdownEnd = () => {
            counting.value = false;
        };
        /** 打sendOTP之前要打OTP集中檢核otpCheck/checkBDPOTP，result=Ｙ跳視窗 */
        const checkOTP = async () => {
            isSpin.value = true;
            setTimeout(() => {
                isSpin.value = false;
                selectMobile.value = false;
            }, 3000);

            if (await chooseOtp()) {
                postCheckBDPOTP(otpMobile.value).then((res) => {
                    if (res.data.result === 'Y') {
                        modalShow(dialogContnet.checkBDPOTP);
                    } else {
                        sendOTP();
                    }
                }).finally(() => {
                    isLoading.value = false;
                });
            } else {
                isLoading.value = false;
            }
        };

        const chooseOtp = () => {
            const data = {
                mobileCountry: '',
                mobile: otpMobile.value,
            };
            return postChooseOtp(data).then(() => {
                return true;
            });
        };

        const initOtpNotify = () => {
            return getContactInfo().then(() => true);
        };

        const getData = async () => {
            isLoading.value = true;
            if (await initOtpNotify()) {
                getInfoOTP().then((res) => {
                    const { beforeMobile, mobile, mobileList } = res.data;
                    mobileNumber.old = beforeMobile;
                    mobileNumber.lastNumber = mobile;
                    mobileNumber.mobileList = mobileList || [];
                    otpMobile.value = beforeMobile === '' && mobile;
                }).finally(() => {
                    isLoading.value = false;
                });
            } else {
                isLoading.value = false;
            }
        };

        getData();

        const goNext = () => {
            if (!otpCode.value) {
                errorMsg.value = '動態密碼未輸入，請確認！';
                return;
            } else {
                errorMsg.value = '';
            }
            isSpin.value = true;
            postVerifyOTP(otpCode.value, otpMobile.value).then(res => {
                const { verify, cancelTransaction, errorTimes } = res.data;
                verifyErrorTimes.value = errorTimes;
                if (verify) {
                    // todo NON 導向註冊頁
                    if (isNONCustom.value) {
                        router.push({
                            name: routeName.ENOTIFY_REGISTER
                        });
                    } else {
                        router.push({
                            name: routeName.FINISH
                        });
                    }
                } else if (cancelTransaction) {
                    modalShow(dialogContnet.otpError5Times);
                } else {
                    otpCode.value = '';

                    notification({
                        title: '驗證失敗',
                        text: '驗證碼錯誤'
                    });
                }
                setTimeout(() => {
                    isSpin.value = false;
                }, 1000);
            });
        };

        return {
            onCountdownEnd,
            resendOtp,
            checkOTP,
            goNext,
            maskMobile,
            sendTimes,
            isInputDisabled,
            selectMobile,
            otpCode,
            isLoading,
            counting,
            isSpin,
            otpMobile,
            errorMsg,
            ...toRefs(mobileNumber)
        };
    },
};
</script>
